<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.7305 8.10671C20.7305 5.65757 18.7489 3.67212 16.2969 3.67212C13.7147 3.67212 10.3019 3.67212 7.7197 3.67212C5.26766 3.67212 3.28601 5.65757 3.28601 8.10671C3.28601 9.71005 3.28601 11.5726 3.28601 13.1769C3.28601 14.3529 3.74639 15.4809 4.57709 16.3126C5.40778 17.1442 6.53872 17.6116 7.7197 17.6116H8.60044C8.60044 18.4143 8.60044 19.7074 8.60044 19.7074C8.60044 19.9456 8.73055 20.1628 8.94072 20.2688C9.1609 20.3739 9.41111 20.3479 9.60127 20.2028L12.9741 17.6116H16.2969C17.4778 17.6116 18.5988 17.1442 19.4295 16.3126C20.2702 15.4809 20.7305 14.3529 20.7305 13.1769V8.10671ZM15.4762 11.1633H8.13005C7.78976 11.1633 7.50953 11.4435 7.50953 11.7888C7.50953 12.1341 7.78976 12.4143 8.13005 12.4143H15.4762C15.8265 12.4143 16.1067 12.1341 16.1067 11.7888C16.1067 11.4435 15.8265 11.1633 15.4762 11.1633ZM12.4136 8.44199H8.13005C7.78976 8.44199 7.50953 8.72222 7.50953 9.06751C7.50953 9.4118 7.78976 9.69303 8.13005 9.69303H12.4136C12.7639 9.69303 13.0441 9.4118 13.0441 9.06751C13.0441 8.72222 12.7639 8.44199 12.4136 8.44199Z"
      fill="#3CA091"
    />
  </svg>
</template>

<script>
export default {
  name: 'ChatSelected'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
